
import clsx from 'clsx'
import React, { FC, useContext } from 'react'

import { Button } from '@CoreComponents/Buttons/Button'
import { BillwerkContext } from '@Domains/Checkout/Providers/BillwerkContextProvider'
import {
  useBillwerkCheckoutResponse,
} from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Components/ProviderComponents/Billwerk/Hooks/useBillwerkCheckoutResponse'
import { CheckoutPaymentComponentProps } from '@Domains/CheckoutV2/Features/CheckoutSteps/Steps/CheckoutPaymentStep/Hooks/usePaymentComponentFactory'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useTranslation } from '@Globals/Translations'

import styles from './BillwerkRedirect.module.scss'

export const BillwerkRedirectButton: FC<CheckoutPaymentComponentProps> = ({ option, submitPayment, submitWithoutData }) => {
  const cofDesignV1 = useSplitTest('cof_design_v1', 'b')
  const { t } = useTranslation()
  const { billwerkInstance } = useContext(BillwerkContext)
  const { handleBillwerkResponse } = useBillwerkCheckoutResponse()

  return (
    <div key={option.id} className={styles.billwerkRedirectButtonWrapper}>
      <Button
        className={clsx(cofDesignV1 ? styles.cofDesignV1 : styles.billwerkRedirectButton)}
        innerSpacing="medium"
        onClick={() => {
          submitPayment(
            submitWithoutData
              ? null
              : null,
            response => handleBillwerkResponse(billwerkInstance, response),
          )
        }}
        type="button"
      >
        {t('checkout:COF_GO_TO_SECURE_PAYMENT')}
      </Button>
    </div>
  )
}
